import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiBaseUrl, apiKey } from "../../../utils/config";

export const placeOrder = createAsyncThunk(
    'order/placeOrder',
    async (orderPayload, { rejectWithValue }) => {
        try {
            let token = localStorage.getItem("token");

            const response = await axios.post(`${apiBaseUrl}/trade/order`, {
                api_key: apiKey,  // Static
                // account: 97543134,          // Static
                account: orderPayload.account,          // Static
                symbol: orderPayload.symbol, // Dynamic
                volume: orderPayload.volume, // Dynamic
                price: "0",                  // Static
                type: orderPayload.type,     // Dynamic (SELL or BUY)
                tp: orderPayload.tp,                     // Static
                sl: orderPayload.sl,                     // Static
                comment: ""                  // Static
            },
                {
                    headers: {
                        "Trade-Account-Token": token
                    }
                }
            );

            // console.log("Order API raw response:", response);
            return response.data;
        } catch (error) {
            console.error("Order API error:", error.response?.data || error.message);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const orderSlice = createSlice({
    name: 'order',
    initialState: {
        orderStatus: 'idle',
        orderData: null,
        error: null,
        orderMessage: '',
        orderFailedMesage: ''
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(placeOrder.pending, (state) => {
                state.orderStatus = 'loading';
                state.orderData = null;
                state.error = null;
            })
            .addCase(placeOrder.fulfilled, (state, action) => {
                state.orderStatus = 'succeeded';
                state.orderData = action.payload;
                // console.log('action payload',action.payload);

                state.orderMessage = action.payload?.message || "Trade Failed";
            })
            .addCase(placeOrder.rejected, (state, action) => {
                state.orderStatus = 'failed';
                state.error = action.payload;
            });
    }
});

export default orderSlice.reducer;
